import { AuthContext } from "contexts/AuthContext";
import { useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Container from "components/Library/Container";
import Form from "components/Library/Form";
import Button from "components/Library/Button";
import Input from "components/Library/Input";
import useForm from "hooks/useForm";
import {
  emailValidations,
  passwordValidations,
} from "utils/validations/loginValidations";

function Login() {
  const authContext = useContext(AuthContext);
  const [loading, setLoading] = useState(false);
  const [formValues, handleInputChange, errors, setErrors] = useForm({
    email: "",
    password: "",
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);

    const formErrors = {
      ...emailValidations(formValues),
      ...passwordValidations(formValues),
    };
    setErrors(formErrors);

    if (Object.keys(formErrors).length === 0) {
      authContext.logUser(formValues);
    } else {
      setLoading(false);
    }
  };

  useEffect(() => {
    setErrors(authContext.errorMessage);
    setLoading(false);
  }, [setErrors, authContext.errorMessage]);

  return (
    <Container>
      <Form className="form form--sm" onSubmit={handleSubmit}>
        <h1 className="form__title">Inicio de sesión</h1>
        <Input
          type="email"
          placeholder="Correo electrónico"
          name="email"
          value={formValues.email}
          error={errors.email}
          onChange={handleInputChange}
        />
        <Input
          type="password"
          placeholder="Contraseña"
          name="password"
          value={formValues.password}
          error={errors.password}
          onChange={handleInputChange}
        />
        <Link className="link" to="/forgotpassword">
          ¿Olvidaste contraseña?
        </Link>
        <div className="form__buttons">
          <Link className="button button--secondary" to="/">
            Regresar
          </Link>
          <Button type="submit" value="Iniciar sesión" disabled={loading} />
        </div>
      </Form>
    </Container>
  );
}

export default Login;
